export const PAYROLL_SOURCES_EVENT = 'fw_payroll_sources'
